<template>
    <component :is="isList ? 'li' : 'div'" :class="isList ? 'list-group-item li-product' : `col mb-4 col-${colSize} col-sm-12`" style="display: none">
        <div :id="`product-card-${block.id}-${product.uid ? product.uid : product.id}`" :class="`h-100 ${isList ? 'media rounded product-card' : 'card text-center '} `">

                <div :class="isList ? 'justify-content-center align-self-center col-md-2': ''">
                    <img v-if="isList || product.image_url" :class="isList ? 'img-fluid': 'card-img-top'" :src="product.image_url ? product.image_url : 'https://activitymessenger.com/img/frontend/blocks/id-card.png'" />
                </div>

                <div :class="isList ? 'media-body pt-4 pb-4 pl-4': 'card-body'">
                    <h5 class="card-title">{{ product.name }}</h5>
                    <p class="card-text text-left" :style="!isList ? 'min-height: 24px;' : ''">
                        {{ product.short_description }}
                    </p>
                    <small v-if="product.maximum_attendance" class="d-block">
                        <i v-if="isList" class="fa fa-user mr-1"></i> {{ `${product.maximum_attendance - product.participant_count} ${trans('remaining_spots').toLowerCase()}` }}
                    </small>
                    <small v-if="product.location" class="d-block mt-2">
                        <i v-if="isList" class="fa fa-map-marker mr-1"></i> {{ product.location.name }}
                    </small>

                    <DescriptionMore
                        :text="product.description"
                        :words="100"
                        v-if="!!product.description"
                        class="my-2"
                    >
                        <div v-html="product.description"></div>
                    </DescriptionMore>

                    <h2 v-if="!isList">
                        <dollar :value="product.price" :months="product.force_recurring ? product.duration : null" />
                    </h2>
                </div>

                <div class="justify-content-left align-self-center mr-4 col-md-4 event-times" v-if="isList && productType == 'class'">
                    <div v-if="!!product.microsite_registration_questions[0].options.custom_schedule" v-html="product.microsite_registration_questions[0].options.custom_schedule"></div>
                    <EventsSchedule
                        v-if="!product.microsite_registration_questions[0].options.custom_schedule"
                        :organization="organization"
                        :cls="product"
                        :events="product.events"
                        :hide-times="product.microsite_registration_questions[0].options.hide_times || false"
                        :hideUpcoming="true"
                    />
                </div>

                <h2 v-if="isList && (!invoice_items || (invoice_items && invoice_items.length == 0))" class="justify-content-center align-self-center mr-2" style="margin-top: -5px;min-width: 100px;">
                    <dollar :value="product.microsite_registration_questions && product.microsite_registration_questions[0].options.price ? product.microsite_registration_questions[0].options.price : product.price" :months="product.force_recurring ? product.duration : null" />
                </h2>

                <div  v-if="isList" class="justify-content-center align-self-center mr-3">
                    <div v-for="invoice_item in invoice_items" class="text-left" >
                        <b-button variant="success" size="sm" disabled>
                            <i class="fa fa-fw fa-check"></i>
                        </b-button>
                        <span class="ml-2">
                            x {{ invoice_item.quantity }}
                            =<dollar v-model="invoice_item.price * invoice_item.quantity" class="ml-1 lead font-weight-bold" />
                        </span>
                        <b-button variant="link" size="sm" class="ml-2 text-danger" :disabled="busy" @click="onRemoveFromCart(invoice_item)">
                            <i class="fa fa-fw fa-times"></i>
                        </b-button>
                    </div>
                </div>

                <div :class="isList ? 'justify-content-center align-self-center mr-3': 'card-footer border-top-0 bg-transparent'">
                        <b-form inline :class="!isList ? 'justify-content-center' : 'float-right'" @submit.prevent="onAddToCart">
                            <b-form-group class="mb-2 number-spinner" v-if="productType == 'product'">
                                <b-form-spinbutton
                                    v-model="quantity"
                                    size="sm"
                                    inline
                                    :min="1"
                                    :max="product.quantity || 100"
                                    :disabled="busy"
                                />
                            </b-form-group>
                            <b-form-group class="mb-2 ml-2">
                                <b-button variant="branded" size="sm" @click="productType == 'class' ? onAddClass() : onAddToCart()" :disabled="busy" class="add-to-cart-btn">
                                    <i v-if="!busy" class="fa fa-fw fa-plus"></i>
                                    <i v-if="busy" class="fa fa-fw fa-circle-notch fa-spin"></i>
                                </b-button>
                            </b-form-group>
                            <b-form-invalid-feedback :state="error ? false : null">
                                {{ error }}
                            </b-form-invalid-feedback>
                        </b-form>

                        <div v-for="invoice_item in invoice_items" class="d-inline-block text-left" v-if="!isList">
                            <b-button variant="success" size="sm" disabled>
                                <i class="fa fa-fw fa-check"></i>
                            </b-button>
                            <span class="ml-2">
                                x {{ invoice_item.quantity }}
                                =<dollar v-model="invoice_item.price * invoice_item.quantity" class="ml-1 lead font-weight-bold" />
                            </span>
                            <b-button variant="link" size="sm" class="ml-2 text-danger" :disabled="busy" @click="onRemoveFromCart(invoice_item)">
                                <i class="fa fa-fw fa-times"></i>
                            </b-button>
                        </div>

                        <ClassRegisterModal
                            v-if="amClass.id"
                            :organization="organization"
                            :am-class="amClass"
                            :id="amClass.id"
                            :hideRegButton="true"
                        />
                </div>

        </div>
    </component>
</template>
<style>
@media screen and (max-width: 575px) {
    .product-card{
        flex-direction: column;
        text-align: center;
        align-items: center;
    }
    .add-to-cart-btn{
        margin-top: 15px;
    }
    .event-times{
        margin-bottom: 15px;
    }
    .number-spinner{
        margin-top: 15px;
    }
}
.list-group-item.li-product{
    border-right-style: solid 7px #fff !important;
    border-left-style: solid 7px #fff !important;
}
</style>
<script>
import Dollar from './../billing/Dollar'
import ApplyCoupon from './PackageApplyCoupon'
import ProductAdminOptions from './ProductAdminOptions'
import ClassRegisterModal from './../microsite/ClassRegisterModal'
import DescriptionMore from './../../../common/components/DescriptionMore'
import EventsSchedule from './../class/EventsSchedule2'

export default {
    props: {
        organization: Object,
        block: Object,
        product: Object,
        colSize: String,
        initialInvoice: Object,
        value: Object,
        isList: {
          type: Boolean,
          default: false,
        }
    },
    components: {
        Dollar,
        ApplyCoupon,
        ProductAdminOptions,
        ClassRegisterModal,
        DescriptionMore,
        EventsSchedule
    },
    data() {
        return {
            trans: trans,
            numeral: numeral,
            busy: false,
            error: null,
            quantity: 1,
            code: null,
            show_apply_coupon: false,
            amClass: {},
            invoice: this.value,
        }
    },
    computed: {
        invoice_items() {
            if (!this.invoice ||
            !this.invoice.invoice_items ||
            this.invoice.invoice_items.length == 0)
            return null
            return _.filter(this.invoice.invoice_items, {[`${this.productType == 'class' ? 'am_class' : this.productType}_id`]: this.product.id})
        },
        productType(){
            if(this.product.type == 'am_event') {
                return 'class';
            } else {
                return 'product';
            }
        },
        participant(){
            return this.block.meta && this.block.meta.form && this.block.meta.form && this.block.meta.form.participant && this.block.meta.form.participant ? this.block.meta.form.participant : {}
        }
    },
    watch: {
        value() {
            this.invoice = this.value;
        },
    },
    methods: {
        onCloseApplyCoupon() {
            this.show_apply_coupon = false
        },
        onCouponApplied(invoice) {
            this.$emit('input', invoice)
            this.onCloseApplyCoupon()
        },
        onAdminOptionsApplied(invoice) {
            this.$emit('input', invoice)
        },
        removeCoupon(invoice_item) {
            this.busy = true
            this.error = null
            let url = `/org/${this.organization.id}/cart/${this.productType}/${invoice_item.id}/coupon`
            axios.delete(url)
            .then(response => {
                this.busy = false
                this.invoice = response.data
                this.$emit('input', response.data)
            })
            .catch(error => {
                this.busy = false
                this.error = _.errorFromAjax(error)
            })
        },
        onAddToCart(meta) {
            this.busy = true
            this.error = null

            axios.post(`/org/${this.organization.id}/cart/${this.productType}`, {
                [`${this.productType}_id`]: this.product.id,
                quantity: this.quantity,
                block: this.block,
                form_id: this.block.meta && this.block.meta.form && this.block.meta.form.default_form ? this.block.meta.form.default_form : null,
                meta
            })
            .then(response => {
                this.busy = false
                this.invoice = response.data
                this.$emit('input', response.data)
            })
            .catch(error => {
                this.busy = false
                this.error = _.errorFromAjax(error)
                _.toastError(this, this.error)
            })
        },
        onRemoveFromCart(invoice_item) {
            this.busy = true
            this.error = null
            axios.delete(`/org/${this.organization.id}/cart/${this.productType}/${invoice_item.id}`)
            .then(response => {
                this.busy = false
                this.invoice = response.data
                this.$emit('input', response.data)
            })
            .catch(error => {
                this.busy = false
                this.error = _.errorFromAjax(error)
                _.toastError(this, this.error)
            })
        },
        onAddClass() {
            this.amClass = this.product
            window.classRegisterAmClassId = this.product.id

            setTimeout(() => {
                this.$bvModal.show(`class-register-modal${this.product.id}`) // for some reason, loads the class-reg somewhere else so added id
            }, 200);

            window.onClassAddToCart = (question, meta) => {
                meta.id = question.id
                this.$bvModal.hide(`class-register-modal${this.product.id}`)
                this.onAddToCart(meta)
            }
        },
    },
    mounted() {
        window['product_' + this.product.id] = this
    },
}
</script>
